import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchProduct } from '../api/productsApi';
import ProductBreadcrumb from '../components/product/ProductBreadcrumb';
import ProductGallery from '../components/product/ProductGallery';
import ProductInfo from '../components/product/ProductInfo';
import ProductTabs from '../components/product/ProductTabs';
import RelatedProducts from '../components/product/RelatedProducts';

const LoadingState = () => (
  <div className="flex min-h-[60vh] items-center justify-center bg-brand-deep">
    <div className="flex items-center gap-3 rounded-2xl border border-line bg-card px-6 py-4">
      <div className="h-5 w-5 animate-spin rounded-full border-2 border-brand border-t-transparent" />
      <span className="text-sm text-muted">Loading product...</span>
    </div>
  </div>
);

const ErrorState = ({ message }) => (
  <div className="flex min-h-[60vh] items-center justify-center bg-brand-deep">
    <div className="max-w-md rounded-2xl border border-line bg-card p-8 text-center">
      <p className="text-sm text-muted">{message || 'Product not found.'}</p>
      <a href="/products" className="mt-4 inline-block rounded-xl bg-brand px-6 py-2.5 text-sm font-semibold text-black transition-colors hover:bg-brand-dark">
        Browse Products
      </a>
    </div>
  </div>
);

export default function ProductDetail() {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      setErr('');
      try {
        const p = await fetchProduct(productId);
        if (mounted) setProduct(p);
      } catch (e) {
        if (mounted) setErr(e?.message || 'Failed to load product');
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [productId]);

  if (loading) return <LoadingState />;
  if (!product) return <ErrorState message={err} />;

  const handleBuyNow = () => {
    const phone = '917404704959';
    const text = encodeURIComponent(`Hi, I'm interested in buying ${product.title} (SKU: ${product.sku || product.id})`);
    window.open(`https://wa.me/${phone}?text=${text}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-brand-deep font-sans text-white">
      <div className="mx-auto w-full max-w-[1600px] px-4 pt-12 pb-4 md:px-8 md:py-6">
        {/* Breadcrumb */}
        <ProductBreadcrumb product={product} />

        {/* Product Hero */}
        <div className="flex flex-col gap-6 lg:grid lg:grid-cols-2 lg:gap-10">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <ProductGallery product={product} />
          </div>
          <div>
            <ProductInfo product={product} onBuyNow={handleBuyNow} />
          </div>
        </div>

        {/* Tabs + Content */}
        <div className="mt-10 md:mt-14">
          <ProductTabs product={product} />
        </div>

        {/* Related Products */}
        <RelatedProducts product={product} />
      </div>
    </div>
  );
}
